import { RouteObject } from 'react-router-dom';
import React from 'react';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../../navigation/util/PathUtil';
import { StudyArchivingDefaultRoute } from '../container/StudyArchivingDefaultRoute';

const lazyLoadPages: () => Promise<typeof import('./studyArchivingPages')> = () =>
  import(/* webpackPrefetch: true */ './studyArchivingPages');

const Layout = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.StudyArchivingLayout,
  })),
);
const ArchivingFiles = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.StudyArchivingFilesPage,
  })),
);
const ArchivingSiteList = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.StudyArchivingSiteListPage,
  })),
);

export const studyArchivingRoutes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: `${PathUtil.toRelativePath(
          CspPath.STUDY_OVERVIEW_ARCHIVING,
          CspPath.STUDY_OVERVIEW_ARCHIVING_FILES,
          true,
        )}/*`,
        element: <ArchivingFiles />,
        loader: async ({ params }) => (await lazyLoadPages()).studyArchivingFilesPagePreload(params['*'] ?? ''),
      },
      {
        path: PathUtil.toRelativePath(CspPath.STUDY_OVERVIEW_ARCHIVING, CspPath.STUDY_OVERVIEW_ARCHIVING_SITES, true),
        element: <ArchivingSiteList />,
      },
      {
        path: '',
        element: <StudyArchivingDefaultRoute />,
      },
    ],
  },
];
